import * as React from 'react';

import { LoyaltyEducationPerks } from 'models/common/loyalty-education';

import { LoyaltyEducationPerksContent } from './loyalty-education-perks-content';

interface LoyaltyEducationSectionContentProps {
  title: string;
  perks: LoyaltyEducationPerks;
  description: string;
}

export const LoyaltyEducationSectionContent: React.FunctionComponent<LoyaltyEducationSectionContentProps> = ({
  title,
  perks,
  description,
}) => (
  <React.Fragment>
    {title && <h4 className="uitk-type-heading-300 all-b-margin-one uitk-type-bold">{title}</h4>}
    <LoyaltyEducationPerksContent perks={perks} />
    {description && <p className="uitk-type-paragraph-300 all-b-margin-three">{description}</p>}
  </React.Fragment>
);
